var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThunder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 34,
    viewBox: "0 0 19 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09817 1.91653L0.897594 16.3726C0.897594 16.3726 0.646806 17.0489 0.897594 17.3237C1.1044 17.5503 1.66134 17.5139 1.66134 17.5139H5.48007L0.897594 32.1602C0.897594 32.1602 0.553911 32.9211 1.08853 33.3015C1.62315 33.6819 2.23415 33.1113 2.23415 33.1113L18.1613 12.9443C18.1613 12.9443 18.9251 12.1428 18.6547 11.6173C18.4715 11.2614 17.7 11.2369 17.7 11.2369H13.4994L17.8909 1.91653C17.8909 1.91653 18.0326 1.41712 17.8909 1.15568C17.6444 0.700965 16.9363 0.775258 16.9363 0.775258H6.24422C6.24422 0.775258 5.76465 0.775258 5.48046 1.15568C5.29692 1.40139 5.09817 1.91653 5.09817 1.91653Z",
    fill: "url(#paint0_linear_4000_28995)",
    stroke: "#FFC120",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4000_28995",
    x1: 19.6888,
    y1: 17.129,
    x2: 0.786133,
    y2: 17.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411789,
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC39"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.01d318128f8e0b62ef551cc7aa044a7f.svg";
export { ForwardRef as ReactComponent };